import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-pagination',
  templateUrl: './blog-pagination.component.html',
})
export class BlogPaginationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
